<template>
  <div class="row justify-content-center no-gutters">
    <div class="col col-md-9">
      <form
        :action="$laraRoute('widget.update-profile')"
        method="POST"
        @submit.prevent="handleForm"
        id="widget-form"
        enctype="multipart/form-data"
        novalidate
      >
        <div class="form-group justify-content-start align-items-center row mb-1">
          <label
            for="language"
            class="col-4 mx-250"
          ><span v-translate>Language</span></label>
          <div class="col-8 col-sm-5 col-md-4 mx-240">
            <CustomSelect :options="$language.available" :label="'language'" :handler="languageHandler" :hasValue="$language.available[user.language]">
              <template slot-scope="{slotKey}">
                <span :class="`${$codes[slotKey] ? $codes[slotKey].class : null}`"></span>&nbsp;
              </template>
            </CustomSelect>
          </div>
        </div>
<!--        <div class="form-group justify-content-start align-items-center row mb-1">-->
<!--          <label-->
<!--            for="themes"-->
<!--            class="col-4 mx-250"-->
<!--          ><span v-translate>Theme</span></label>-->
<!--          <div class="col-8 col-sm-5 col-md-4 mx-240">-->
<!--            <CustomSelect :options="themes" :label="'theme'" :handler="themeHandler" :hasValue="theme">-->
<!--              <template slot-scope="{slotKey}">-->
<!--                <span :class="`${$codes[slotKey] ? $codes[slotKey].class : null}`"></span>&nbsp;-->
<!--              </template>-->
<!--            </CustomSelect>-->
<!--          </div>-->
<!--        </div>-->
        <div class="form-group justify-content-start align-items-center row mb-1">
          <label
            for="fullname"
            class="col-4 mx-250"
          ><span v-translate>Full Name</span></label>
          <div class="col-8 col-sm-5 col-md-4 mx-240">
            <p class="asInput">{{ user.full_name }}</p>
          </div>
        </div>
        <div class="form-group justify-content-start align-items-center row mb-1">
          <label
            for="nickname"
            class="col-4 mx-250"
          ><span v-translate>Avatar Name</span></label>
          <div class="col-8 col-sm-5 col-md-4 mx-240">
            <Input
              :rule="'nickname'"
              name="nickname"
              errorType="nickname"
              model="user.nickname"
              module="Widget"
              :required="true"
            />
          </div>
        </div>
        <div class="form-group justify-content-start align-items-start row mb-1">
          <label
            for="avatar"
            class="col-4 mx-250"
          ><span v-translate>Profile Picture</span> <span
            class="label-inner"
            v-translate
          >(Optional)</span></label>
          <div class="col-8 col-sm-6 col-md-4 mx-350">
            <file-upload
              :existing-file="this.user.profile_pic_url"
              id="avatar"
            ></file-upload>
          </div>
        </div>
        <div class="row">
          <div class="col-auto">
            <a
              class="btn btn-hollow btn-f-m"
              @click.prevent="openPasswordResetWidget"
              v-translate
            >
              Change Password
            </a>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-md-8">
            <flash-message></flash-message>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import CustomSelect from '@C/CustomSelect';
import FileUpload from '@C/FileUpload';
import Input from '@C/Forms/Input';
import FlashMessage from '@C/FlashMessage';
import validator from '@M/validationWrapper';

export default {
  name: 'SystemTab',
  props: {
    user: {
      type: Object,
      required: true
    },
    openPasswordResetWidget: {
      type: Function,
      required: true
    },
    loadData: {
      type: Function,
      required: true
    },
    setHasLoaded: {
      type: Function,
      requried: true
    }
  },
  data() {
    return {
      themes: ['Dark Theme', 'Light Theme'],
      theme: ''
    }
  },
  created() {
    this.theme = this.user.sc2_theme
  },
  methods: {
    ...mapActions('Widget', {
      setLanguage: 'setLanguage',
      setTheme: 'setTheme'
    }),
    ...mapActions('Widget', ['updateProfileMinimum']),
    languageHandler(e) {
      let target = e.target || e;
      let optionEl = target[target.selectedIndex];

      let val = target.value;

      this.setLanguage(optionEl.getAttribute('data-key'));
    },
    themeHandler(e) {
      let target = e.target || e;
      let optionEl = target[target.selectedIndex];

      let val = target.value;
      this.setTheme(val);
    },
    formHandler() {
      this.updateProfileMinimum().then(() => {
        this.setHasLoaded(false);
        this.loadData();
      });
    }
  },
  components: {
    CustomSelect,
    FileUpload,
    Input,
    FlashMessage
  },
  mixins: [validator]
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/stages/Widgets/Tabs/System.vue